export default __webpack_public_path__ + "static/LOGO-BLS-2020-BLC-01318e46a1b2d1cb47457645b7830ae2.png";